define('constants/removePlanFeedbackConstants',['i18next'], function() {
    const _i18n = require('i18next');

    return {
        reasons: {
            lacksFeatures: {
                id: "LacksFeatures",
                description: _i18n.t('removePlan:reasons.lacksFeatures'),
            },
            tooDifficult: {
                id: "TooDifficult",
                description:  _i18n.t('removePlan:reasons.tooDifficult')
            },
            tooExpensive: {
                id: "TooExpensive",
                description: _i18n.t('removePlan:reasons.tooExpensive')
            },
            billingProblem: {
                id: "BillingProblem",
                description: _i18n.t('removePlan:reasons.billingProblem')
            },
            technicalProblem: {
                id: "TechnicalProblem",
                description: _i18n.t('removePlan:reasons.technicalProblem')
            },
            poorCustomerService: {
                id: "PoorCustomerService",
                description: _i18n.t('removePlan:reasons.poorCustomerService')
            },
            noLongerNeeded: {
                id: "NoLongerNeeded",
                description: _i18n.t('removePlan:reasons.noLongerNeeded')
            },
            other: {
                id: "Other",
                description: _i18n.t('removePlan:reasons.other')
            }
        },
        noLongerNeededReasons: {
            temporaryCampaign: {
                id: "TemporaryCampaign",
                description: _i18n.t('removePlan:noLongerNeededReasons.temporaryCampaign')
            },
            noLongerInBusiness: {
                id: "NoLongerInBusiness",
                description: _i18n.t('removePlan:noLongerNeededReasons.noLongerInBusiness')
            },
            notUsingIt: {
                id: "NotUsingIt",
                description: _i18n.t('removePlan:noLongerNeededReasons.notUsingIt')
            },
            other: {
                id: "Other",
                description: _i18n.t('removePlan:noLongerNeededReasons.other')
            }
        },
        tooExpensiveReasons: {
            notGoodValue: {
                id: "NotGoodValue",
                description: _i18n.t('removePlan:tooExpensiveReasons.notGoodValue')
            },
            taxesAndFeesTooHigh: {
                id: "TaxesAndFeesTooHigh",
                description: _i18n.t('removePlan:tooExpensiveReasons.taxesAndFeesTooHigh')
            },
            other: {
                id: "Other",
                description: _i18n.t('removePlan:tooExpensiveReasons.other')
            }
        }
    };
});
